<template>
  <div class="row">
    <div class="col-12 col-lg-2">
      <nav>
        <div v-if="$store.getters.isMod">
          <h1 class="nav-header">Content</h1>
          <ul class="nav-group">
            <li><router-link :to="{ name: 'recipes' }">Recipes</router-link></li>
            <li><router-link :to="{ name: 'ingredients' }">Ingredients</router-link></li>
            <li><router-link :to="{ name: 'articles' }">Articles</router-link></li>
          </ul>
        </div>
        <div v-if="$store.getters.isAdmin">
          <h1 class="nav-header">Social</h1>
          <ul class="nav-group">
            <li><router-link :to="{ name: 'comments' }">Comments</router-link></li>
            <li><router-link :to="{ name: 'snaps' }">Snaps</router-link></li>
            <li><router-link :to="{ name: 'requests' }">Requests</router-link></li>
            <li><router-link :to="{ name: 'newsletters' }">Newsletters</router-link></li>
          </ul>
        </div>
        <div v-if="$store.getters.isDistributor">
          <h1 class="nav-header">Commerce</h1>
          <ul class="nav-group">
            <li><router-link :to="{ name: 'orders' }">Orders</router-link></li>
            <li><router-link :to="{ name: 'inventories' }">Inventories</router-link></li>
            <li><router-link :to="{ name: 'products' }">Products</router-link></li>
            <li><router-link :to="{ name: 'categories' }">Categories</router-link></li>
            <li><router-link :to="{ name: 'distributors' }">Distributors</router-link></li>
            <li><router-link :to="{ name: 'brands' }">Brands</router-link></li>
          </ul>
        </div>
        <div v-if="$store.getters.isAdmin">
          <h1 class="nav-header">Statistics</h1>
          <ul class="nav-group">
            <li><router-link :to="{ name: 'users' }">Users</router-link></li>
            <li><router-link :to="{ name: 'subscribers' }">Mailing List</router-link></li>
          </ul>
        </div>
        <ul class="nav-group">
          <li><a tabindex="0" style="cursor: pointer; outline: none;" @click="onLogout">Logout</a></li>
        </ul>
      </nav>
    </div>
    <div class="col-12 col-lg-10">
      <div v-if="!$store.state.user.active" style="margin-bottom: 15px;">
        <el-alert title="Account Disabled" type="error" description="Your account has been disabled. Please contact the help desk if this is mistaken." :closable="false" show-icon></el-alert>
      </div>
      <div v-if="!$store.state.user.verified" style="margin-bottom: 15px;">
        <el-alert title="Pending Verification" type="info" description="Your account is not yet verified. Please visit the settings page to confirm your email address." :closable="false" show-icon></el-alert>
      </div>
      <transition name="view" mode="out-in" appear>
        <router-view :key="$route.fullPath"/>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    async onLogout() {
      try {
        var { data } = await this.$store.dispatch('logout')
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }
      window.location.href = '/login'
    },
    async handleCommand(item) {
      console.log(item)
      if (item === 'logout') {
        await this.onLogout()
      } else {
        this.$router.push({ name: item })
      }
    },
  },
}
</script>

<style scoped>
nav ul {
  padding-left: 0;
  list-style: none;
}

nav ul li {
  margin-bottom: .5rem;
}

nav a {
  color: #95a3b3;
  text-decoration: none;
}

nav a.router-link-active {
  font-weight: 700;
  color: #333966;
}

.nav-header {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  color: #95a3b3;
  margin-bottom: .75rem;
}

.btn-home {
  margin-bottom: 2rem;
}

ul.nav-group {
  margin-bottom: 2rem;
}

.view-enter-active, .view-leave-active {
  transition: opacity 75ms ease-in-out;
}

.view-enter, .view-leave-to {
  opacity: 0;
}

.view-leave, .view-enter-to {
  opacity: 1;
}
</style>
